export { default } from '../../sub/cookies-info';

